import React from "react";
import { EmptyState } from "@/components/consultation/EmptyState";
import {
  DismissibleChip,
  ChipContainer,
} from "@/components/consultation/shared/DismissibleChip";
import {
  Widget,
  WidgetHeader,
  WidgetContent,
} from "@/components/consultation/shared/Widget";
import { usePatientMedicines } from "@/hooks/useConsultation";

interface PatientMedicationsCardProps {
  appointmentId: string;
}

export const PatientMedicationsCard = ({
  appointmentId,
}: PatientMedicationsCardProps) => {
  const { data: medicines, isLoading } = usePatientMedicines(appointmentId);
  const medicineList = medicines?.medicines || [];

  return (
    <Widget grow className="h-full">
      <WidgetHeader title="Medications (Patient Shared)" hasInfo />
      <WidgetContent className="flex-1 min-h-0 overflow-y-auto scrollbar-thin">
        {isLoading ? (
          <div className="flex items-center justify-center h-full">
            <span className="z-body text-muted-foreground">Loading...</span>
          </div>
        ) : medicineList.length === 0 ? (
          <EmptyState title="Not enough data available" variant="compact" />
        ) : (
          <ChipContainer>
            {medicineList.map((med: any, index: number) => (
              <DismissibleChip
                key={index}
                label={med.name || "Unknown Medicine"}
              />
            ))}
          </ChipContainer>
        )}
      </WidgetContent>
    </Widget>
  );
};
